import { useEffect, useState } from "react";
import { Modal, message, Spin } from "antd";
import axios from "axios";
import messages from "../../errors/messages.en-IN.json";

const QRCodeModal = ({ qrCodeData, paymentMethod, visible, onClose, qrPaymentCallback, setQRCodeModalVisible }) => {
  const API_URL = `${process.env.REACT_APP_API_URL}api/paymentGateway/razorPay`;
  const [timeLeft, setTimeLeft] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!visible || !qrCodeData) return;

    let poll; // Polling interval
    let timer; // Countdown timer

    const payloadData = paymentMethod?.paymentProviderDetails?.providerConfigurations;
    const stringifiedData = payloadData ? JSON.stringify(payloadData) : null;

    const pollPaymentStatus = async () => {
      let attempts = 0;
      const initialMaxAttempts = 60;
      const extraAttempts = 10; // Additional 10 seconds (10 * 1s)
      const maxAttempts = initialMaxAttempts + extraAttempts; // Total 70 seconds
      const interval = 1000; // Poll every 1 seconds
      const countdownStart = 20; // Start countdown at 20 seconds

      poll = setInterval(async () => {
        attempts += 1;
        const secondsElapsed = attempts * (interval / 1000);
        const initialDuration = initialMaxAttempts * (interval / 1000); // 60 seconds
        const remainingInitialSeconds = initialDuration - secondsElapsed;

        // Start countdown timer when 20 seconds or less remain in initial period
        if (remainingInitialSeconds <= countdownStart && attempts <= initialMaxAttempts && !timer) {
          setTimeLeft(Math.ceil(remainingInitialSeconds));
          timer = setInterval(() => {
            setTimeLeft((prev) => {
              if (prev <= 1) {
                clearInterval(timer); // Stop countdown timer
                setTimeLeft(null); // Hide countdown
                setIsLoading(true); // Show loading symbol
                return 0;
              }
              return prev - 1;
            });
          }, 1000);
        }

        try {
          const statusResponse = await axios.get(`${API_URL}/poll-qr?qrId=${qrCodeData.id}&payloadData=${stringifiedData}`);
          console.log("polling response=========", statusResponse.data);
          const { status } = statusResponse.data;

          if (status === "closed") {
            clearInterval(poll);
            if (timer) clearInterval(timer);
            setIsLoading(false);
            setTimeLeft(null);
            qrPaymentCallback(statusResponse.data);
            setQRCodeModalVisible(false);
            onClose();
          } else if (attempts >= maxAttempts) {
            // Only show timeout after all attempts (including extra 10 seconds)
            clearInterval(poll);
            if (timer) clearInterval(timer);
            setIsLoading(false);
            setTimeLeft(null);
            message.info(`${messages.errors.payments.payment_timeout}`);
            onClose();
          }
        } catch (error) {
          clearInterval(poll);
          if (timer) clearInterval(timer);
          setIsLoading(false);
          setTimeLeft(null);
          message.error(`${messages.info.payment_failed}`);
          console.error("Error polling Razorpay QR status:", error);
          onClose();
        }
      }, interval);
    };

    pollPaymentStatus();

    // Cleanup on unmount or when visible changes
    return () => {
      if (poll) clearInterval(poll);
      if (timer) clearInterval(timer);
      setTimeLeft(null);
      setIsLoading(false);
    };
  }, [visible, qrCodeData, qrPaymentCallback, onClose, setQRCodeModalVisible, paymentMethod]);

  return (
    <Modal
      title={isLoading ? "Processing Payment" : "Scan to Pay"}
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      bodyStyle={{
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "400px",
      }}
    >
      {qrCodeData && !isLoading ? (
        <div
          style={{
            textAlign: "center",
            width: "100%",
          }}
        >
          <img
            src={qrCodeData.image_url}
            alt="Razorpay QR Code"
            style={{
              width: "75%",
              maxWidth: "450px",
              height: "73vh",
              margin: "0 auto",
              display: "block",
            }}
          />
          <p
            style={{
              marginTop: "20px",
              fontSize: "16px",
            }}
          >
            Scan the QR code to complete the payment
          </p>
          {timeLeft !== null && (
            <p
              style={{
                marginTop: "10px",
                fontSize: "16px",
                color: "red",
              }}
            >
              Time remaining: {timeLeft} seconds
            </p>
          )}
        </div>
      ) : isLoading ? (
        <div
          style={{
            textAlign: "center",
            width: "100%",
          }}
        >
          <Spin size="large" />
        </div>
      ) : null}
    </Modal>
  );
};

export default QRCodeModal;
